import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "external-search-results" }
const _hoisted_2 = { class: "external-search-results__header" }
const _hoisted_3 = { class: "flex" }
const _hoisted_4 = { style: {"max-width":"500px"} }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "page-items__hr" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NButton = _resolveComponent("NButton")!
  const _component_SortDropdown = _resolveComponent("SortDropdown")!
  const _component_FilterDateRange = _resolveComponent("FilterDateRange")!
  const _component_ExternalSearchResultsTable = _resolveComponent("ExternalSearchResultsTable")!
  const _component_InfiniteScroll = _resolveComponent("InfiniteScroll")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _createVNode(_component_NButton, {
          icon: "arrow-left",
          type: "secondary",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('back')))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('common.search', 'f')), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_SortDropdown, {
          items: _ctx.sortTypes,
          modelValue: _ctx.module.filter.current.ordering,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.module.filter.current.ordering) = $event))
        }, null, 8, ["items", "modelValue"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_ctx.module.filter.current)
            ? (_openBlock(), _createBlock(_component_FilterDateRange, {
                key: 0,
                "clear-button": false,
                hasIntervals: false,
                model: _ctx.module.filter.current,
                "gte-prop": "event_timestamp_gte",
                "lte-prop": "event_timestamp_lte"
              }, null, 8, ["model"]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _hoisted_5,
    _createVNode(_component_ExternalSearchResultsTable, {
      results: _ctx.enrichedSearchResults,
      onDisplayCardImage: _ctx.dispatchDisplayCardImageEvent,
      onDisplayEventImage: _ctx.dispatchDisplayEventImageEvent
    }, null, 8, ["results", "onDisplayCardImage", "onDisplayEventImage"]),
    _createVNode(_component_InfiniteScroll, {
      onLoadMore: _cache[2] || (_cache[2] = () => _ctx.module.append())
    })
  ]))
}